import { render, staticRenderFns } from "./beikeReservation.vue?vue&type=template&id=174ccbe5&"
import script from "@viewJs/reservation/beikeReservation.js?vue&type=script&lang=js&"
export * from "@viewJs/reservation/beikeReservation.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports